module.exports = __webpack_public_path__ + "static/media/route-icon.a77c96f3.svg";